import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Card, CardBody, CardFooter, Col, Container, Form, FormGroup, Input, Label, Row, Table } from "reactstrap";
import { toast } from "react-toastify";

import { confirm } from "components/Confirmation";

import loteService from "services/LoteService";
import CustomPagination from "components/CustomPagination";
import IconButton from "components/IconButton";
import comboService from "services/ComboService";
import estadoService from "services/EstadoService";

export default function Lotes() {
  const [pagina, setPagina] = useState(1)
  const [paginas, setPaginas] = useState(0)
  const [estados, setEstados] = useState([])
  const [municipios, setMunicipios] = useState([])
  const [fiscais, setFiscais] = useState([])

  const [termo, setTermo] = useState(null)
  const [idFiscal, setIdFiscal] = useState(null)
  const [uf, setUf] = useState(null)
  const [idMunicipio, setIdMunicipio] = useState(null)

  const [items, setItems] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    setEstados(estadoService.get())
    comboService.fiscal().then(res => {
      if (res.success) {
        setFiscais(res.data)
      } else {
        setFiscais([])
      }
    })
  }, [])

  useEffect(() => {
    if (!!uf)
      comboService.municipio(uf).then(res => {
        if (res.success) {
          setMunicipios(res.data)
        } else {
          setMunicipios([])
        }
      })
  }, [uf])

  const carregar = async () => {
    const res = await loteService.get(termo, idFiscal, uf, idMunicipio, pagina)
    if (res.success) {
      setItems(res.data.items)
      setPaginas(res.data.paginas)
    }
  }

  useEffect(() => {
    carregar()
  }, [pagina])

  const handleDelete = (item) => {
    confirm({
      header: "Exclusão",
      text: "Tem certeza que gostaria de continuar?",
      icon: "bi-exclamation-triangle",
      onConfirm: async () => {
        try {
          const res = await loteService.delete(item.id)
          if (res.success) {
            carregar()
            toast("Lote excluído")
          } else {
            toast("Erro ao excluir o lote")
          }
        } catch (ex) {
          toast("Erro ao excluir o lote")
        }
      }
    })
  }

  const handleSubmit = e => {
    e.preventDefault()
    setPagina(1)
    carregar()
  }

  return (
    <>
      <Container fluid>
        <div className="d-flex flex-row justify-content-between align-items-center">
          <h1 className="my-4">Lotes</h1>
          <Link className="btn btn-primary btn-icon" to="/admin/lotes/0">Incluir</Link>
        </div>

        <Card className="shadow mb-4">
          <CardBody>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col>
                  <FormGroup>
                    <Label>Nome ou Região</Label>
                    <Input type="text" placeholder="Nome ou Região" value={termo || ''} onChange={e => setTermo(e.target.value)} />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label>Fiscal</Label>
                    <select className="form-control" value={idFiscal || ''} onChange={e => setIdFiscal(e.target.value)}>
                      <option value="">Todos</option>
                      {fiscais.map(el => (
                        <option key={el.id} value={el.id}>{el.nome}</option>
                      ))}
                    </select>
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label>Estado</Label>
                    <select className="form-control" value={uf || ''} onChange={e => setUf(e.target.value)}>
                      <option value="">Todos</option>
                      {estados.map(el => (
                        <option key={el.sigla} value={el.sigla}>{el.nome}</option>
                      ))}
                    </select>
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label>Cidade</Label>
                    <select className="form-control" value={idMunicipio || ''} onChange={e => setIdMunicipio(e.target.value)}>
                      <option value="">Todos</option>
                      {municipios.map(el => (
                        <option key={el.id} value={el.id}>{el.nome}</option>
                      ))}
                    </select>
                  </FormGroup>
                </Col>
                <Col className="d-flex align-items-end justify-content-end">
                  <FormGroup>
                    <Button type="submit" color="primary">Buscar</Button>
                  </FormGroup>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>

        <Card className="shadow">
          <Table className="align-items-center table-flush" responsive>
            <thead className="thead-light">
              <tr>
                <th scope="col">Nome</th>
                <th scope="col">Região</th>
                <th scope="col">Município</th>
                <th scope="col">Fiscal</th>
                <th scope="col" style={{ width: 120 }}></th>
              </tr>
            </thead>
            <tbody>
              {items.length == 0 && (
                <tr>
                  <td colSpan={4} className="text-center">Nenhum registro</td>
                </tr>
              )}
              {items.map(el => (
                <tr key={el.id}>
                  <td>{el.nome}</td>
                  <td>{el.regiao}</td>
                  <td>{el.municipio} / {el.uf}</td>
                  <td>{el.fiscal}</td>
                  <td className="d-flex flex-row gap-5px">
                    <IconButton alt="Editar" iconClass="bi-pencil-square" onClick={() => navigate("/admin/lotes/" + el.id)} />
                    <IconButton alt="Excluir" iconClass="bi-trash" onClick={() => handleDelete(el)} />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <CardFooter className="py-4">
            <CustomPagination pagina={pagina} paginas={paginas} onChange={setPagina} />
          </CardFooter>
        </Card>
     </Container>
    </>
  )
}